import { CargoTransporterTableDTO } from '../../../Domain/DTO/CargoTransporterTableDTO';
import { ListIntOptionDTO } from '../../../Domain/DTO/ListIntOptionDTO';

export class CargoTransporterUserHelperProps{
    SelectedCargoTransporter: CargoTransporterTableDTO;
    SelectedRole: ListIntOptionDTO;
}

export const InitialCargoTransporterUserHelperProps: CargoTransporterUserHelperProps = <CargoTransporterUserHelperProps>{ };